(function () {
  'use strict';

  function internalEvent(eventName, element, fields) {
    document.dispatchEvent(new CustomEvent('kiki:breed-launch-event', {
      detail: { eventName: eventName, element: element, fields: fields || {} }
    }));
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function compactLayout() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function updateStickyOffset(root) {
    var header = document.querySelector('.section-header');
    var height = header ? header.getBoundingClientRect().height : 0;
    var offset = Math.ceil(height + 16);
    root.style.setProperty('--kiki-sticky-offset', offset + 'px');
    return offset;
  }

  function scrollToFeedback(root, selected) {
    var offset = updateStickyOffset(root);
    var top = window.scrollY + selected.getBoundingClientRect().top - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  }

  function init(root) {
    var selected = root.querySelector('[data-breed-selected-route]');
    var selectedContent = root.querySelector('[data-breed-selected-content]');
    var triggers = Array.from(root.querySelectorAll('[data-breed-route]'));
    var selectedHome = document.createComment('breed selected route home');
    selected.before(selectedHome);

    function restoreSelectedHome() {
      selectedHome.parentNode.insertBefore(selected, selectedHome.nextSibling);
    }

    function placeSelected(trigger) {
      var item = trigger.closest('.kiki-breed-context__route-item');
      if (compactLayout() && item) item.appendChild(selected);
      else restoreSelectedHome();
    }

    function clearSelection() {
      triggers.forEach(function (item) {
        item.removeAttribute('aria-current');
        item.setAttribute('aria-expanded', 'false');
        item.closest('.kiki-breed-context__route-item').classList.remove('is-selected');
      });
      root.removeAttribute('data-active-breed-route');
      selected.hidden = true;
      selectedContent.replaceChildren();
      restoreSelectedHome();
    }

    function updateHistory(routeKey, method) {
      var url = new URL(window.location.href);
      if (routeKey) url.searchParams.set('breed_route', routeKey);
      else url.searchParams.delete('breed_route');
      window.history[method + 'State']({ breedRoute: routeKey || null }, '', url.pathname + url.search + url.hash);
    }

    function activateRoute(trigger, options) {
      var template = root.querySelector('template[data-breed-route-content="' + trigger.dataset.breedRoute + '"]');
      if (!template) return;
      var previousRoute = root.dataset.activeBreedRoute || '';
      triggers.forEach(function (item) {
        item.removeAttribute('aria-current');
        item.setAttribute('aria-expanded', 'false');
        item.closest('.kiki-breed-context__route-item').classList.remove('is-selected');
      });
      trigger.setAttribute('aria-current', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.closest('.kiki-breed-context__route-item').classList.add('is-selected');
      root.dataset.activeBreedRoute = trigger.dataset.breedRoute;
      var fragment = template.content.cloneNode(true);
      var summary = fragment.querySelector('[data-route-summary]');
      selectedContent.replaceChildren(summary);
      selected.hidden = false;
      placeSelected(trigger);
      if (options.history) updateHistory(trigger.dataset.breedRoute, options.history);
      if (options.focus) selected.focus({ preventScroll: true });
      if (options.scroll) scrollToFeedback(root, selected);
      if (options.userInitiated && previousRoute !== trigger.dataset.breedRoute) {
        internalEvent('wagnudge_breed_route_select', trigger, {
          route_key: trigger.dataset.breedRoute,
          interaction_method: options.interactionMethod || 'pointer'
        });
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        activateRoute(trigger, {
          history: 'push',
          focus: true,
          scroll: true,
          userInitiated: true,
          interactionMethod: event.detail === 0 ? 'keyboard' : 'pointer'
        });
      });
      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activateRoute(trigger, {
          history: 'push',
          focus: true,
          scroll: true,
          userInitiated: true,
          interactionMethod: event.key === ' ' ? 'space' : 'enter'
        });
      });
    });

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-breed-destination-type][href]');
      if (!link || !root.contains(link)) return;
      var destinationType = link.dataset.breedDestinationType || '';
      if (destinationType !== 'problem') return;
      internalEvent('wagnudge_breed_problem_click', link, {
        route_key: link.dataset.problemKey || root.dataset.activeBreedRoute || '',
        destination_type: destinationType,
        destination_handle: link.dataset.breedDestinationHandle || '',
        product_handle: '',
        interaction_method: event.detail === 0 ? 'keyboard' : 'pointer'
      });
    });

    window.addEventListener('popstate', function () {
      var routeKey = new URL(window.location.href).searchParams.get('breed_route');
      var trigger = triggers.find(function (item) { return item.dataset.breedRoute === routeKey; });
      if (trigger) activateRoute(trigger, { focus: true, scroll: true });
      else clearSelection();
    });

    window.addEventListener('resize', function () {
      var current = triggers.find(function (item) { return item.getAttribute('aria-current') === 'true'; });
      updateStickyOffset(root);
      if (current) placeSelected(current);
    });

    updateStickyOffset(root);
    var initialRoute = new URL(window.location.href).searchParams.get('breed_route');
    var initialTrigger = triggers.find(function (item) { return item.dataset.breedRoute === initialRoute; });
    if (initialTrigger) activateRoute(initialTrigger, { focus: false, scroll: false });
  }

  document.querySelectorAll('[data-kiki-component="breed-context-hub"]').forEach(init);
})();
